// src/whitelabel/useTenant.js
import tenants from "./tenants";

const getTenantKeyFromHost = () => {
  const host = window.location.hostname;
  if (host.includes("clienty")) return "clienty";
  if (host.includes("clientx")) return "clientx";
  return "default";
};

export const useTenant = () => {
  const key = getTenantKeyFromHost();
  return tenants[key] || tenants["default"];
};
